'use strict';
mpangoApp.controller('MbudgetController',MbudgetController);
function MbudgetController($filter,$rootScope, $scope,$state,$window, Mbudget,Mvendor ,Mreports, Notification, SweetAlert, $uibModal, $filter) {
	$scope.$on('$viewContentLoaded', function () {
        Mbudget.getItems().success(function(data,status) {
            $scope.items = data.items;      
    		$scope.totalcollection = data.sumcol;		
    	}).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
        Mvendor.getVendors().success(function  (data,status) {
            $scope.mvendors = data.mvendors;
        });
    });
    $scope.calcEstamount = function(dataitem) {
        $scope.e_amount = dataitem.e_quantity * dataitem.e_unit_price;
    }
    $scope.changeVname = function(data) {
        var v = parseInt(data);
        if (v != 0) {
            var selected = $filter('filter')($scope.mvendors, {id: data});
            if (typeof(selected) !== 'undefined') {
                var vname = selected.length ? selected[0].v_name : null;
                return vname; 
            }; 
        };
    };
    $scope.exportDoc = function(tempname,xtype, id) {
        Mreports.toExcel(tempname,xtype,id).success(function  (data,status) {
            var token = $rootScope.sytoken;
            var url = 'index.php/api/toexcel?data='+tempname+'&eId='+id+'&xtype='+xtype+'&token='+token;
            $window.open(url);
        }).error(function(data,status){
            $state.go('auth');
            Notification.error({message: 'Token expired, please login', delay: 3000});
        });
    };
    $scope.sort = function(keywoo){
        $scope.sortKey = keywoo;   
        $scope.reverse = !$scope.reverse; 
    }
    $scope.currentPage = 1;
    $scope.pageSize = 10;
    $scope.pageChangeHandler = function(num) {};
    $scope.openv = function  (templatename,size,vId) {
        $scope.vendordetail = $filter('filter')($scope.mvendors, { id: vId });
        var modalInstance = $uibModal.open({
            templateUrl: templatename,
            keyboard: false,
            backdrop: 'static',
            size: size,
            resolve:{
                    tablename:function  () {
                        return $scope.vendordetail;
                    }
                },
            controller: function  ($scope,tablename, $uibModalInstance) {
                $scope.vendordetail = tablename;
                $scope.cancel = function  () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };
    $scope.open = function  (templatename,size) {
        var modalInstance = $uibModal.open({
            templateUrl: templatename,
            keyboard: false,
            backdrop: 'static',
            size: size,
            resolve:{
                tablename:function  () {
                    return $scope.items;
                }
            },
            controller: function  ($scope,tablename, $uibModalInstance) {
                $scope.add = function  (itemdata,e_amount,valid) {
                    if (valid == true) {
                        itemdata.e_amount = e_amount;
                        $uibModalInstance.close();
                        Mbudget.postItem(itemdata).success(function  (data,status) {
                            $scope.items = tablename;
                            $scope.items.push(data.insertedD);
                            Notification.success({message: data.message});
                        }).error(function(data,status){
                            $state.go('auth');
                            Notification.error({message: 'Token expired, please login', delay: 3000});
                        }); 
                    }
                };
                $scope.cancel = function  () {
                    $uibModalInstance.dismiss('cancel');
                };
            }
        });
    };
    $scope.update = function(itemdata,formname,index) {
        if (formname == 'itemupdate') {
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Update budget data",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Mbudget.updateItem(itemdata,formname).success(function(data) {
                    Notification.success({message: data.message});
                    $state.reload();
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
                }
            });
           
        }
        if(formname == 'delete'){
            SweetAlert.swal({
                title: "Are you sure?",
                text: "Delete budget data",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",confirmButtonText: "Yes,delete!",
                cancelButtonText: "No, cancel!",
                closeOnConfirm: true,
                closeOnCancel: true }, 
            function(isConfirm){ 
                if (isConfirm) {
                    Mbudget.updateItem(itemdata,formname).success(function(data) {
                        $scope.items.splice(index, 1);
                        Notification.success({message: data.message});        
                    }).error(function(data,status){
                        $state.go('auth');
                        Notification.error({message: 'Token expired, please login', delay: 3000});
                    });
                } else {
                  SweetAlert.swal("Cancelled", "Your data is safe!", "error");
                }
            });
            
        }            
    };
}
MbudgetController.$inject = ['$filter','$rootScope', '$scope','$state','$window', 'Mbudget','Mvendor' ,'Mreports', 'Notification', 'SweetAlert', '$uibModal', '$filter'];